import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';

export const essVenueStructureQuizLayout: Record<
  EssTopic,
  { sections: Array<EssSection> }
> = {
  [EssTopic.PARITY_EQUALITY]: {
    sections: [
      EssSection.PERMANENT_OPERATIONAL_TEAM,
      EssSection.TRANSPARENCY_MANAGEMENT,
    ],
  },
  [EssTopic.ACCESSIBILITY_SOCIAL_DIALOGUE]: {
    sections: [
      EssSection.ACCESSIBILITY,
      EssSection.RISK_PREVENTION,
      EssSection.COMMUNICATION,
      EssSection.TEAM_MANAGEMENT,
    ],
  },
  [EssTopic.LOCAL_IMPACT_RSE_ENGAGEMENT]: {
    sections: [
      EssSection.LOCALITY_EMPLOYMENT_PARTNERS,
      EssSection.ECONOMIC_SOCIAL_IMPACT,
    ],
  },
};
